
import { accommodationMapping } from '../mappings/AccommodationMapping';

export const applyAccommodationFilter = (dbQuery: any, accommodationType: string) => {
  const accommodationKeywords = accommodationMapping[accommodationType as keyof typeof accommodationMapping];
  
  if (!accommodationKeywords || accommodationKeywords.length === 0) {
    console.log('No keywords found for accommodation type:', accommodationType);
    return dbQuery;
  }
  
  console.log('Applying accommodation filter for:', accommodationType);
  console.log('Using keywords:', accommodationKeywords);
  
  // Eenvoudige OR-filtering binnen de al gefilterde locatie
  const orConditions = accommodationKeywords.map(keyword => 
    `typeAccommodatie.ilike.%${keyword}%`
  ).join(',');
  
  console.log('Generated OR conditions:', orConditions);
  
  return dbQuery.or(orConditions);
};
